import { CallApiOptions } from './api';
import { uniq } from 'ramda';

export const fetchProductsCallOptions = (
  appId: number,
  productIds: number[]
): CallApiOptions => {
  return {
    method: 'GET',
    endpoint: `proxies/mobile/${appId}/products/${uniq(productIds).join(',')}`,
  };
};

export const searchProductsCallOptions = (
  categoryId: number,
  appId: number = 428,
  limit: number = 1,
  offset: number = 0,
  filters = {}
): CallApiOptions => ({
  method: 'GET',
  endpoint: `proxies/mobile/${appId}/search/products/${categoryId}`,
  params: { appId, limit, offset, filters: JSON.stringify(filters) },
});



// WEBPACK FOOTER //
// ./src/services/products.services.ts